import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'theSource/app/routes';
import { List } from 'theSource/components';
import { Entries } from 'theSource/types';
import { ADDITIONAL_NAVIGATION_ICONS } from 'theSource/utils';
import { PanelStyled } from './PanelStyled';

interface PanelProps {
  hideDrawer?: boolean;
}

export const Panel = ({ hideDrawer = false }: PanelProps) => {
  const location = useLocation();
  const navRoutes = ROUTES.additional;
  const finalNavRountes = {
    profile: navRoutes['profile'],
    benefits: navRoutes['benefits'],
    company: navRoutes['company'],
  };
  return (
    <>
      {!hideDrawer && (
        <PanelStyled
          data-testid="permanent-drawer"
          variant="permanent"
          anchor="left"
        >
          <Stack spacing={5}>
            {(
              Object.entries(finalNavRountes) as Entries<
                typeof ROUTES.additional
              >
            ).map(([heading, routes], index) => (
              <List
                key={index}
                subheaderInfo={{
                  icon: ADDITIONAL_NAVIGATION_ICONS[heading],
                  title: heading,
                }}
                items={Object.values(routes)}
                selectedLocation={location.pathname}
              />
            ))}
          </Stack>
        </PanelStyled>
      )}
    </>
  );
};
